import api from 'app/admin/services/api';

class StoreAddressesService {
  apiUrl = '/admin/storeaddresses';
  primaryUrl = `${this.apiUrl}/primary`;
  addressUrl = `${this.apiUrl}/address`;

  add = (address) => {
    return api.post(this.addressUrl, {
      address: address
    });
  }

  getAddresses = () => {
    return api.get(this.apiUrl, true);
  }

  getPrimaryAddress = () => {
    return api.get(this.primaryUrl, true)
      .then((primaryAddress) => {
        if (!primaryAddress || !primaryAddress.mailingAddress) {
          return Promise.reject({});
        }
        return primaryAddress;
      });
  }

  updatePrimaryAddress = (address) => {
    if (!address.isPrimary) {
      address.isPrimary = true;
    }
    return api.post(this.primaryUrl, {
      address
    }, true);
  }

  save = (data) => {
    return api.post(this.apiUrl, {
      storeAddresses: data
    }, true);
  }

  hasPrimaryStoreAddress = () => {
    return api.get(this.primaryUrl, true)
      .then((primaryAddress) => {
        return (primaryAddress && primaryAddress.mailingAddress);
      }).catch(() => {
        return false;
      });
  }
}

export default new StoreAddressesService();



// WEBPACK FOOTER //
// ./src/app/admin/services/storeAddresses/StoreAddressesService.js